import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { useMemo } from 'react'
import {
  RolodexEntryType,
  TimeSeriesDerivedValueEntry,
  TimeSeriesDerivedValueEntrySchema,
} from 'types'
import { z } from 'zod'

interface UseDerivedValuesProps {
  derivedValueIds?: string[]
  tags?: Record<string, string[]>
}

export const useDerivedValues = ({
  derivedValueIds,
  tags,
}: UseDerivedValuesProps = {}) => {
  const loadOptions = useMemo(() => {
    return {
      type: [RolodexEntryType.TIME_SERIES_DERIVED_VALUE],
      ...(derivedValueIds && derivedValueIds.length > 0
        ? { ids: derivedValueIds }
        : {}),
      ...(tags ? { tags } : {}),
      limit: derivedValueIds?.length ?? 10000,
    }
  }, [derivedValueIds, tags])

  const { data, error, isLoading, isValidating, mutate } =
    useGetRolodexEntriesByLoadOptions<TimeSeriesDerivedValueEntry[]>(
      loadOptions
    )

  // Parse the raw data with Zod schema to transform snake_case to camelCase
  const derivedValues = useMemo(() => {
    if (!data) return []
    try {
      return z
        .array(TimeSeriesDerivedValueEntrySchema)
        .parse(data)
        .map((item) => item.entry)
    } catch (error) {
      console.error('Failed to parse derived values:', error)
      return []
    }
  }, [data])

  return {
    derivedValues,
    error,
    isLoading,
    isValidating,
    mutate,
  }
}
